export default __webpack_public_path__ + "static/media/adam_person_icon.09cf4f42.png";